/**
 * Site-wide copy constants. Price formatting lives in `pricing.ts` — that module is the only
 * one in the PWA that turns a number into price copy (01 §7, D6, D7). Render and cart
 * disclaimers are not client constants at all: the API sends them on the payload
 * (`render.disclaimer`, `cart.disclaimer`), so the server stays the single source of truth
 * for legally-required wording.
 */

export const SITE_PROMISE =
  'Andrew confirms everything on site and gives you one fixed, all-in price in writing.'
